module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('form', {
    staticClass: "row px-0 mx-0"
  }, [_c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Codigo del cliente:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.codigo
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block"
  }, [_vm._v("Documento:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dniNumber),
      expression: "dniNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.inputDisabled
    },
    domProps: {
      "value": (_vm.dniNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dniNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.inputChangeDisabled.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.inputDisabled ? "Quitar Disabled" : "Agregar Disabled") + "\n        ")]), _vm._v(" "), (_vm.inputDisabled === false) ? _c('button', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeNumberDni.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Cambiar número de DNI\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("E-mail de cuenta:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.email
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Estado de Verificado:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.varificado.verified ? 'Verificado' : 'Sin verificar'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Tipo de Registro:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.estado
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("URL DNI anterior -> Estado - " + _vm._s(_vm.credential.statuAnterior) + " : ("), _c('a', {
    attrs: {
      "href": _vm.credential.dniAnterior,
      "target": "_Blank"
    }
  }, [_vm._v("Revisar")]), _vm._v("\n          )")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: [
      (_vm.credential.statuAnterior === 1 ? '' : '') ||
      (_vm.credential.statuAnterior === 2 ? 'border border-warning' : '') ||
      (_vm.credential.statuAnterior === 3 ? 'border border-success' : '') ||
      (_vm.credential.statuAnterior === 4 ? 'border border-danger' : '') ],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.dniAnterior
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dni.anterior),
      expression: "dni.anterior"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dni, "anterior", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeStatusDni(true)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("1 - El usuario no subio ningún archivo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("2 - En espera para que el Admin verifique")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("3 - DNI anterior verificado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("4 - Archivo Rechazado")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("URL DNI posterior -> Estado - " + _vm._s(_vm.credential.statuPosterior) + " : ("), _c('a', {
    attrs: {
      "href": _vm.credential.dniPosterior,
      "target": "_Blank"
    }
  }, [_vm._v("Revisar")]), _vm._v(")\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: [
      (_vm.credential.statuPosterior === 1 ? '' : '') ||
      (_vm.credential.statuPosterior === 2 ? 'border border-warning' : '') ||
      (_vm.credential.statuPosterior === 3 ? 'border border-success' : '') ||
      (_vm.credential.statuPosterior === 4 ? 'border border-danger' : '') ],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.dniPosterior
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dni.posterior),
      expression: "dni.posterior"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dni, "posterior", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeStatusDni(false)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("1 - El usuario no subio ningún archivo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("2 - En espera para que el Admin verifique")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("3 - DNI posterior verificado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("4 - Archivo Rechazado")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2161f5b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-user/CredentialComponent.vue
// module id = 1859
// module chunks = 1